import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

/**
 * Cross-page just-in-time coachmark signal. A page sets a target before navigating elsewhere;
 * the destination page reads it once, shows the spotlight, and clears it. Kept generic so other
 * onboarding hand-offs (turf, volunteers, …) can reuse it.
 */
interface CoachmarkState {
  /** Identifier of the coachmark to show on the next page (e.g. 'voter-import'), or null. */
  target: string | null;
  request: (target: string) => void;
  clear: () => void;
}

export const useCoachmarkStore = create<CoachmarkState>()(
  devtools(
    (set) => ({
      target: null,
      request: (target) => set({ target }),
      clear: () => set({ target: null }),
    }),
    { name: 'coachmark-store' }
  )
);
